module.exports = __webpack_public_path__ + "d3ff64e99c2c32bb578def0085b842cb.pdf";